import Bank from '@/generated/classes/Bank';
export default class BankExtend extends Bank {
  constructor() {
    super();
  }
}
